import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {
  TouchableOpacity,
  Animated,
  Easing,
} from 'react-native';

import { View } from 'react-native';

import Arrow from '../../arrow';
import ExpandableListRowContent from './expandable-list-row-content';

import styles, { arrowSVGStyles } from './expandable-list-row.styles';

const ANIMATION_DURATION = 300;

export default class ExpandableListRow extends PureComponent {
  static propTypes = {
    children: PropTypes.node.isRequired,
    expandedContent: PropTypes.node,
    expanded: PropTypes.bool,
    canExpand: PropTypes.bool,
    onPress: PropTypes.func,
    onLayout: PropTypes.func,
  };

  static defaultProps = {
    expanded: false,
    canExpand: true,
    onPress: () => {
    },
  };

  constructor(props) {
    super(props);
    this.state = {
      arrowAnim: new Animated.Value(props.expanded ? 1 : 0),
    };
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.expanded !== nextProps.expanded) {
      Animated.timing(
        this.state.arrowAnim,
        {
          duration: ANIMATION_DURATION,
          toValue: nextProps.expanded ? 1 : 0,
          easing: Easing.easeOut,
        }
      ).start();
    }
  }

  render() {
    const {
      expanded,
      expandedContent,
      canExpand,
      onPress,
      onLayout,
      messages,
    } = this.props;
    const { arrowAnim } = this.state;
    const arrowTransform = {
      transform: [{
        rotate: arrowAnim.interpolate({
          inputRange: [0, 1],
          outputRange: ['0deg', '180deg'],
        }),
      }],
    };

    return (
      <View
        onLayout={onLayout}
        testID={`expandable-list-item${expanded ? '-selected' : ''}`}
        style={styles.root}
      >
        <TouchableOpacity
          onPress={onPress}
          disabled={!canExpand}
          style={styles.header}
          testID="header"
        >
          <View style={styles.headerContent}>
            {this.props.children}
          </View>
          <View
            testID={`arrow-${expanded ? 'up' : 'down'}`}
            style={styles.arrowWrapper}
          >
            {canExpand &&
              <Animated.View
                style={[
                  styles.arrow,
                  arrowTransform,
                ]}
              >
                {/*
                <Arrow
                  direction="down"
                  {...arrowSVGStyles}
                />*/}
              </Animated.View>
            }
          </View>
        </TouchableOpacity>
        {expanded && (
          <ExpandableListRowContent>{expandedContent}</ExpandableListRowContent>
        )}
      </View>
    );
  }
}
